import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { gerundsVsInfinitivesData, getDataForDifficulty } from '../courses/data/grammar/gerundsVsInfinitives';

export default function GerundsVsInfinitivesTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : gerundsVsInfinitivesData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
